// extracted by mini-css-extract-plugin
module.exports = {"footer":"style-module--footer--2_TQw","footerText":"style-module--footerText--2HvG5"};